import { clsx } from 'clsx'
import { type ComponentPropsWithoutRef, type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { type OfferV11 } from '@redteclab/api/clients/bully'
import { IconInfo } from '@redteclab/icons'

import {
  ProductVolumePricingModal,
  useProductVolumePricingContext,
} from '../../../../../product'
import { offerAccessorGetVolumePricing } from '../../../../model/offerAccessor/offerAccessorGetVolumePricing'

type ProductOfferVolumePricingLabelProps =
  ComponentPropsWithoutRef<'button'> & {
    className?: string
    currentOffer?: OfferV11
  }

export const ProductOfferVolumePricingLabel: FC<
  ProductOfferVolumePricingLabelProps
> = ({ className, currentOffer }) => {
  const volumePrices = offerAccessorGetVolumePricing(currentOffer)
  const { openableControls } = useProductVolumePricingContext()

  return (
    <>
      <button
        className={clsx(
          'flex items-center rounded-full align-middle text-xs',
          className,
        )}
        data-qa-id="product-offer-volume-price-label"
        onClick={openableControls.handleOpen}
        type="button"
      >
        <FormattedMessage id="volumePricing.otherOffers.label" />
        {volumePrices ? <IconInfo className="ml-1 size-4 shrink-0" /> : null}
      </button>
      {currentOffer && volumePrices ? <ProductVolumePricingModal /> : null}
    </>
  )
}
